import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  ht: {
    // Navbar
    products: "Pwodwi",
    electronics: "Elektwonik",
    clothing: "Rad",
    home: "Kay",
    beauty: "Bote",
    login: "Konekte",
    logout: "Dekonekte",
    myOrders: "Kòmand mwen yo",
    adminPanel: "Admin Panel",
    
    // Home
    welcome: "Byenveni!",
    tagline: "Un simple clic",
    heroTitle: "MRC Boutique, LLC",
    heroDesc: "Dekouvri koleksyon pwodwi nou yo. Tout sa ou bezwen, nan yon sèl kote.",
    shopNow: "Achte Kounye a",
    register: "Enskri",
    categories: "Kategori yo",
    exploreCategories: "Eksplore tout kategori pwodwi nou yo",
    popularProducts: "Pwodwi Popilè",
    discoverPopular: "Dekouvri pwodwi ki pi popilè yo",
    viewAll: "Wè Tout",
    dontMissPromotions: "Pa Rate Pwomosyon yo!",
    signUpForNews: "Enskri kounye a pou resevwa dènye nouvèl ak pwomosyon espesyal yo.",
    createFreeAccount: "Kreye Kont Gratis",
    
    // Features
    fastDelivery: "Livrezon Rapid",
    deliveryDesc: "Livrezon nan tout Ayiti",
    security: "Sekirite",
    securityDesc: "Peman sekirize 100%",
    easyPayment: "Peman Fasil",
    paymentDesc: "Aksepte tout kat",
    
    // Products
    allProducts: "Tout Pwodwi",
    discoverCollection: "Dekouvri koleksyon pwodwi nou yo",
    searchProducts: "Chèche pwodwi...",
    search: "Chèche",
    allCategories: "Tout Kategori",
    clearFilters: "Efase Filtre",
    productsFound: "pwodwi jwenn",
    noProductsFound: "Pa gen pwodwi ki koresponn ak rechèch ou a",
    
    // Product Detail
    backToProducts: "Retounen nan Pwodwi yo",
    available: "Disponib",
    onlyLeft: "Sèlman {count} rete",
    outOfStock: "Pa disponib",
    quantity: "Kantite",
    addToCart: "Ajoute nan Panye",
    deliveryAvailable: "Livrezon disponib",
    qualityGuarantee: "Garanti kalite",
    securePayment: "Peman sekirize",
    similarProducts: "Pwodwi Menm Jan",
    
    // Cart
    yourCart: "Panye Ou",
    itemsInCart: "atik nan panye ou",
    cartEmpty: "Panye ou vid",
    noProductsYet: "Ou poko ajoute okenn pwodwi nan panye ou.",
    continueShopping: "Kontinye Achte",
    orderSummary: "Rezime Kòmand",
    subtotal: "Sou-total",
    shipping: "Livrezon",
    free: "Gratis",
    total: "Total",
    payNow: "Peye Kounye a",
    processing: "Ap trete...",
    loginToCheckout: "Konekte pou wè panye ou epi achte pwodwi.",
    removeFromCart: "Retire nan panye",
    
    // Auth
    email: "Imèl",
    password: "Modpas",
    confirmPassword: "Konfime Modpas",
    fullName: "Non Konplè",
    noAccount: "Ou poko gen kont?",
    haveAccount: "Ou gen kont deja?",
    registerNow: "Enskri",
    loginNow: "Konekte",
    createAccount: "Kreye Kont",
    creatingAccount: "Ap kreye kont...",
    loggingIn: "Ap konekte...",
    
    // Orders
    myOrdersTitle: "Kòmand Mwen yo",
    orders: "kòmand",
    noOrders: "Pa gen kòmand",
    noOrdersYet: "Ou poko fè okenn kòmand.",
    startShopping: "Kòmanse Achte",
    orderNumber: "Nimewo Kòmand",
    date: "Dat",
    paymentStatus: "Estati Peman",
    paid: "Peye",
    pending: "Ap tann",
    
    // Order Status
    statusPending: "Ap tann",
    statusProcessing: "Ap prepare",
    statusShipped: "Voye",
    statusDelivered: "Livre",
    statusCancelled: "Anile",
    
    // Checkout Success
    verifyingPayment: "Ap verifye peman...",
    pleaseWait: "Tann yon moman silvouplè",
    thankYou: "Mèsi pou kòmand ou!",
    paymentSuccess: "Peman ou te reyisi. Nou pral prepare kòmand ou touswit.",
    viewOrders: "Wè Kòmand yo",
    sessionExpired: "Sesyon ekspire",
    errorOccurred: "Yon erè rive",
    sessionExpiredMsg: "Sesyon peman ou ekspire. Tanpri eseye ankò.",
    errorMsg: "Nou pa kapab verifye peman ou. Tanpri kontakte sipò.",
    returnToCart: "Retounen nan Panye",
    
    // Admin
    manageProducts: "Jere pwodwi yo",
    totalProducts: "pwodwi total",
    addProduct: "Ajoute Pwodwi",
    newProduct: "Nouvo Pwodwi",
    editProduct: "Modifye Pwodwi",
    productName: "Non",
    description: "Deskripsyon",
    price: "Pri",
    stock: "Stock",
    category: "Kategori",
    selectCategory: "Chwazi kategori",
    imageUrl: "URL Imaj",
    update: "Mete Ajou",
    createProduct: "Kreye Pwodwi",
    actions: "Aksyon",
    
    // Footer
    quickLinks: "Lyen Rapid",
    customerService: "Sèvis Kliyan",
    trackOrder: "Swiv Kòmand",
    returns: "Retounen Pwodwi",
    faq: "FAQ",
    contactUs: "Kontakte Nou",
    allRightsReserved: "Tout dwa rezève.",
    footerTagline: "Yon sèl klik pou jwenn tout sa ou bezwen. Boutik anliy ou ka fè konfyans.",
    
    // Messages
    addedToCart: "ajoute nan panye!",
    removedFromCart: "Retire nan panye",
    cartUpdated: "Panye mete ajou",
    loginRequired: "Ou dwe konekte pou ajoute nan panye",
    welcomeBack: "Byenveni!",
    accountCreated: "Kont ou kreye! Byenveni nan MRC Boutique!",
    productCreated: "Pwodwi kreye!",
    productUpdated: "Pwodwi mete ajou!",
    productDeleted: "Pwodwi efase!",
    errorAddingToCart: "Erè pandan ajoute nan panye",
    errorCheckout: "Erè pandan kreye sesyon peman",
    fillAllFields: "Ranpli tout chan yo",
    passwordsDontMatch: "Modpas yo pa menm",
    passwordTooShort: "Modpas dwe gen omwen 6 karaktè",
    invalidCredentials: "Email oswa modpas pa bon",
  },
  
  en: {
    // Navbar
    products: "Products",
    electronics: "Electronics",
    clothing: "Clothing",
    home: "Home",
    beauty: "Beauty",
    login: "Login",
    logout: "Logout",
    myOrders: "My Orders",
    adminPanel: "Admin Panel",
    
    // Home
    welcome: "Welcome!",
    tagline: "One simple click",
    heroTitle: "MRC Boutique, LLC",
    heroDesc: "Discover our product collection. Everything you need, in one place.",
    shopNow: "Shop Now",
    register: "Sign Up",
    categories: "Categories",
    exploreCategories: "Explore all our product categories",
    popularProducts: "Popular Products",
    discoverPopular: "Discover our most popular products",
    viewAll: "View All",
    dontMissPromotions: "Don't Miss Our Promotions!",
    signUpForNews: "Sign up now to receive the latest news and special promotions.",
    createFreeAccount: "Create Free Account",
    
    // Features
    fastDelivery: "Fast Delivery",
    deliveryDesc: "Delivery everywhere",
    security: "Security",
    securityDesc: "100% secure payment",
    easyPayment: "Easy Payment",
    paymentDesc: "Accept all cards",
    
    // Products
    allProducts: "All Products",
    discoverCollection: "Discover our product collection",
    searchProducts: "Search products...",
    search: "Search",
    allCategories: "All Categories",
    clearFilters: "Clear Filters",
    productsFound: "products found",
    noProductsFound: "No products match your search",
    
    // Product Detail
    backToProducts: "Back to Products",
    available: "Available",
    onlyLeft: "Only {count} left",
    outOfStock: "Out of stock",
    quantity: "Quantity",
    addToCart: "Add to Cart",
    deliveryAvailable: "Delivery available",
    qualityGuarantee: "Quality guarantee",
    securePayment: "Secure payment",
    similarProducts: "Similar Products",
    
    // Cart
    yourCart: "Your Cart",
    itemsInCart: "items in your cart",
    cartEmpty: "Your cart is empty",
    noProductsYet: "You haven't added any products to your cart yet.",
    continueShopping: "Continue Shopping",
    orderSummary: "Order Summary",
    subtotal: "Subtotal",
    shipping: "Shipping",
    free: "Free",
    total: "Total",
    payNow: "Pay Now",
    processing: "Processing...",
    loginToCheckout: "Login to view your cart and purchase products.",
    removeFromCart: "Remove from cart",
    
    // Auth
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    fullName: "Full Name",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    registerNow: "Sign Up",
    loginNow: "Login",
    createAccount: "Create Account",
    creatingAccount: "Creating account...",
    loggingIn: "Logging in...",
    
    // Orders
    myOrdersTitle: "My Orders",
    orders: "orders",
    noOrders: "No orders",
    noOrdersYet: "You haven't placed any orders yet.",
    startShopping: "Start Shopping",
    orderNumber: "Order Number",
    date: "Date",
    paymentStatus: "Payment Status",
    paid: "Paid",
    pending: "Pending",
    
    // Order Status
    statusPending: "Pending",
    statusProcessing: "Processing",
    statusShipped: "Shipped",
    statusDelivered: "Delivered",
    statusCancelled: "Cancelled",
    
    // Checkout Success
    verifyingPayment: "Verifying payment...",
    pleaseWait: "Please wait a moment",
    thankYou: "Thank you for your order!",
    paymentSuccess: "Your payment was successful. We will prepare your order right away.",
    viewOrders: "View Orders",
    sessionExpired: "Session expired",
    errorOccurred: "An error occurred",
    sessionExpiredMsg: "Your payment session has expired. Please try again.",
    errorMsg: "We couldn't verify your payment. Please contact support.",
    returnToCart: "Return to Cart",
    
    // Admin
    manageProducts: "Manage products",
    totalProducts: "total products",
    addProduct: "Add Product",
    newProduct: "New Product",
    editProduct: "Edit Product",
    productName: "Name",
    description: "Description",
    price: "Price",
    stock: "Stock",
    category: "Category",
    selectCategory: "Select category",
    imageUrl: "Image URL",
    update: "Update",
    createProduct: "Create Product",
    actions: "Actions",
    
    // Footer
    quickLinks: "Quick Links",
    customerService: "Customer Service",
    trackOrder: "Track Order",
    returns: "Returns",
    faq: "FAQ",
    contactUs: "Contact Us",
    allRightsReserved: "All rights reserved.",
    footerTagline: "One click to find everything you need. The online store you can trust.",
    
    // Messages
    addedToCart: "added to cart!",
    removedFromCart: "Removed from cart",
    cartUpdated: "Cart updated",
    loginRequired: "You must login to add to cart",
    welcomeBack: "Welcome back!",
    accountCreated: "Account created! Welcome to MRC Boutique!",
    productCreated: "Product created!",
    productUpdated: "Product updated!",
    productDeleted: "Product deleted!",
    errorAddingToCart: "Error adding to cart",
    errorCheckout: "Error creating payment session",
    fillAllFields: "Fill all fields",
    passwordsDontMatch: "Passwords don't match",
    passwordTooShort: "Password must be at least 6 characters",
    invalidCredentials: "Invalid email or password",
  },
  
  fr: {
    // Navbar
    products: "Produits",
    electronics: "Électronique",
    clothing: "Vêtements",
    home: "Maison",
    beauty: "Beauté",
    login: "Connexion",
    logout: "Déconnexion",
    myOrders: "Mes Commandes",
    adminPanel: "Panneau Admin",
    
    // Home
    welcome: "Bienvenue!",
    tagline: "Un simple clic",
    heroTitle: "MRC Boutique, LLC",
    heroDesc: "Découvrez notre collection de produits. Tout ce dont vous avez besoin, en un seul endroit.",
    shopNow: "Acheter Maintenant",
    register: "S'inscrire",
    categories: "Catégories",
    exploreCategories: "Explorez toutes nos catégories de produits",
    popularProducts: "Produits Populaires",
    discoverPopular: "Découvrez nos produits les plus populaires",
    viewAll: "Voir Tout",
    dontMissPromotions: "Ne Manquez Pas Nos Promotions!",
    signUpForNews: "Inscrivez-vous maintenant pour recevoir les dernières nouvelles et promotions spéciales.",
    createFreeAccount: "Créer un Compte Gratuit",
    
    // Features
    fastDelivery: "Livraison Rapide",
    deliveryDesc: "Livraison partout",
    security: "Sécurité",
    securityDesc: "Paiement 100% sécurisé",
    easyPayment: "Paiement Facile",
    paymentDesc: "Accepte toutes les cartes",
    
    // Products
    allProducts: "Tous les Produits",
    discoverCollection: "Découvrez notre collection de produits",
    searchProducts: "Rechercher des produits...",
    search: "Rechercher",
    allCategories: "Toutes les Catégories",
    clearFilters: "Effacer les Filtres",
    productsFound: "produits trouvés",
    noProductsFound: "Aucun produit ne correspond à votre recherche",
    
    // Product Detail
    backToProducts: "Retour aux Produits",
    available: "Disponible",
    onlyLeft: "Seulement {count} restants",
    outOfStock: "Rupture de stock",
    quantity: "Quantité",
    addToCart: "Ajouter au Panier",
    deliveryAvailable: "Livraison disponible",
    qualityGuarantee: "Garantie qualité",
    securePayment: "Paiement sécurisé",
    similarProducts: "Produits Similaires",
    
    // Cart
    yourCart: "Votre Panier",
    itemsInCart: "articles dans votre panier",
    cartEmpty: "Votre panier est vide",
    noProductsYet: "Vous n'avez pas encore ajouté de produits à votre panier.",
    continueShopping: "Continuer les Achats",
    orderSummary: "Résumé de la Commande",
    subtotal: "Sous-total",
    shipping: "Livraison",
    free: "Gratuit",
    total: "Total",
    payNow: "Payer Maintenant",
    processing: "Traitement...",
    loginToCheckout: "Connectez-vous pour voir votre panier et acheter des produits.",
    removeFromCart: "Retirer du panier",
    
    // Auth
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le Mot de passe",
    fullName: "Nom Complet",
    noAccount: "Vous n'avez pas de compte?",
    haveAccount: "Vous avez déjà un compte?",
    registerNow: "S'inscrire",
    loginNow: "Connexion",
    createAccount: "Créer un Compte",
    creatingAccount: "Création du compte...",
    loggingIn: "Connexion...",
    
    // Orders
    myOrdersTitle: "Mes Commandes",
    orders: "commandes",
    noOrders: "Aucune commande",
    noOrdersYet: "Vous n'avez pas encore passé de commande.",
    startShopping: "Commencer les Achats",
    orderNumber: "Numéro de Commande",
    date: "Date",
    paymentStatus: "Statut du Paiement",
    paid: "Payé",
    pending: "En attente",
    
    // Order Status
    statusPending: "En attente",
    statusProcessing: "En préparation",
    statusShipped: "Expédié",
    statusDelivered: "Livré",
    statusCancelled: "Annulé",
    
    // Checkout Success
    verifyingPayment: "Vérification du paiement...",
    pleaseWait: "Veuillez patienter un moment",
    thankYou: "Merci pour votre commande!",
    paymentSuccess: "Votre paiement a réussi. Nous préparerons votre commande immédiatement.",
    viewOrders: "Voir les Commandes",
    sessionExpired: "Session expirée",
    errorOccurred: "Une erreur s'est produite",
    sessionExpiredMsg: "Votre session de paiement a expiré. Veuillez réessayer.",
    errorMsg: "Nous n'avons pas pu vérifier votre paiement. Veuillez contacter le support.",
    returnToCart: "Retour au Panier",
    
    // Admin
    manageProducts: "Gérer les produits",
    totalProducts: "produits au total",
    addProduct: "Ajouter un Produit",
    newProduct: "Nouveau Produit",
    editProduct: "Modifier le Produit",
    productName: "Nom",
    description: "Description",
    price: "Prix",
    stock: "Stock",
    category: "Catégorie",
    selectCategory: "Sélectionner une catégorie",
    imageUrl: "URL de l'Image",
    update: "Mettre à Jour",
    createProduct: "Créer le Produit",
    actions: "Actions",
    
    // Footer
    quickLinks: "Liens Rapides",
    customerService: "Service Client",
    trackOrder: "Suivre la Commande",
    returns: "Retours",
    faq: "FAQ",
    contactUs: "Nous Contacter",
    allRightsReserved: "Tous droits réservés.",
    footerTagline: "Un clic pour trouver tout ce dont vous avez besoin. La boutique en ligne de confiance.",
    
    // Messages
    addedToCart: "ajouté au panier!",
    removedFromCart: "Retiré du panier",
    cartUpdated: "Panier mis à jour",
    loginRequired: "Vous devez vous connecter pour ajouter au panier",
    welcomeBack: "Bienvenue!",
    accountCreated: "Compte créé! Bienvenue chez MRC Boutique!",
    productCreated: "Produit créé!",
    productUpdated: "Produit mis à jour!",
    productDeleted: "Produit supprimé!",
    errorAddingToCart: "Erreur lors de l'ajout au panier",
    errorCheckout: "Erreur lors de la création de la session de paiement",
    fillAllFields: "Remplissez tous les champs",
    passwordsDontMatch: "Les mots de passe ne correspondent pas",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
    invalidCredentials: "Email ou mot de passe invalide",
  },
  
  es: {
    // Navbar
    products: "Productos",
    electronics: "Electrónica",
    clothing: "Ropa",
    home: "Hogar",
    beauty: "Belleza",
    login: "Iniciar Sesión",
    logout: "Cerrar Sesión",
    myOrders: "Mis Pedidos",
    adminPanel: "Panel Admin",
    
    // Home
    welcome: "¡Bienvenido!",
    tagline: "Un simple clic",
    heroTitle: "MRC Boutique, LLC",
    heroDesc: "Descubre nuestra colección de productos. Todo lo que necesitas, en un solo lugar.",
    shopNow: "Comprar Ahora",
    register: "Registrarse",
    categories: "Categorías",
    exploreCategories: "Explora todas nuestras categorías de productos",
    popularProducts: "Productos Populares",
    discoverPopular: "Descubre nuestros productos más populares",
    viewAll: "Ver Todo",
    dontMissPromotions: "¡No Te Pierdas Nuestras Promociones!",
    signUpForNews: "Regístrate ahora para recibir las últimas noticias y promociones especiales.",
    createFreeAccount: "Crear Cuenta Gratis",
    
    // Features
    fastDelivery: "Entrega Rápida",
    deliveryDesc: "Entrega a todas partes",
    security: "Seguridad",
    securityDesc: "Pago 100% seguro",
    easyPayment: "Pago Fácil",
    paymentDesc: "Acepta todas las tarjetas",
    
    // Products
    allProducts: "Todos los Productos",
    discoverCollection: "Descubre nuestra colección de productos",
    searchProducts: "Buscar productos...",
    search: "Buscar",
    allCategories: "Todas las Categorías",
    clearFilters: "Borrar Filtros",
    productsFound: "productos encontrados",
    noProductsFound: "No hay productos que coincidan con tu búsqueda",
    
    // Product Detail
    backToProducts: "Volver a Productos",
    available: "Disponible",
    onlyLeft: "Solo quedan {count}",
    outOfStock: "Agotado",
    quantity: "Cantidad",
    addToCart: "Añadir al Carrito",
    deliveryAvailable: "Entrega disponible",
    qualityGuarantee: "Garantía de calidad",
    securePayment: "Pago seguro",
    similarProducts: "Productos Similares",
    
    // Cart
    yourCart: "Tu Carrito",
    itemsInCart: "artículos en tu carrito",
    cartEmpty: "Tu carrito está vacío",
    noProductsYet: "Aún no has añadido ningún producto a tu carrito.",
    continueShopping: "Continuar Comprando",
    orderSummary: "Resumen del Pedido",
    subtotal: "Subtotal",
    shipping: "Envío",
    free: "Gratis",
    total: "Total",
    payNow: "Pagar Ahora",
    processing: "Procesando...",
    loginToCheckout: "Inicia sesión para ver tu carrito y comprar productos.",
    removeFromCart: "Eliminar del carrito",
    
    // Auth
    email: "Correo Electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar Contraseña",
    fullName: "Nombre Completo",
    noAccount: "¿No tienes una cuenta?",
    haveAccount: "¿Ya tienes una cuenta?",
    registerNow: "Registrarse",
    loginNow: "Iniciar Sesión",
    createAccount: "Crear Cuenta",
    creatingAccount: "Creando cuenta...",
    loggingIn: "Iniciando sesión...",
    
    // Orders
    myOrdersTitle: "Mis Pedidos",
    orders: "pedidos",
    noOrders: "Sin pedidos",
    noOrdersYet: "Aún no has realizado ningún pedido.",
    startShopping: "Empezar a Comprar",
    orderNumber: "Número de Pedido",
    date: "Fecha",
    paymentStatus: "Estado del Pago",
    paid: "Pagado",
    pending: "Pendiente",
    
    // Order Status
    statusPending: "Pendiente",
    statusProcessing: "En preparación",
    statusShipped: "Enviado",
    statusDelivered: "Entregado",
    statusCancelled: "Cancelado",
    
    // Checkout Success
    verifyingPayment: "Verificando pago...",
    pleaseWait: "Por favor espera un momento",
    thankYou: "¡Gracias por tu pedido!",
    paymentSuccess: "Tu pago fue exitoso. Prepararemos tu pedido de inmediato.",
    viewOrders: "Ver Pedidos",
    sessionExpired: "Sesión expirada",
    errorOccurred: "Ocurrió un error",
    sessionExpiredMsg: "Tu sesión de pago ha expirado. Por favor intenta de nuevo.",
    errorMsg: "No pudimos verificar tu pago. Por favor contacta a soporte.",
    returnToCart: "Volver al Carrito",
    
    // Admin
    manageProducts: "Gestionar productos",
    totalProducts: "productos en total",
    addProduct: "Añadir Producto",
    newProduct: "Nuevo Producto",
    editProduct: "Editar Producto",
    productName: "Nombre",
    description: "Descripción",
    price: "Precio",
    stock: "Stock",
    category: "Categoría",
    selectCategory: "Seleccionar categoría",
    imageUrl: "URL de la Imagen",
    update: "Actualizar",
    createProduct: "Crear Producto",
    actions: "Acciones",
    
    // Footer
    quickLinks: "Enlaces Rápidos",
    customerService: "Servicio al Cliente",
    trackOrder: "Rastrear Pedido",
    returns: "Devoluciones",
    faq: "FAQ",
    contactUs: "Contáctanos",
    allRightsReserved: "Todos los derechos reservados.",
    footerTagline: "Un clic para encontrar todo lo que necesitas. La tienda en línea de confianza.",
    
    // Messages
    addedToCart: "añadido al carrito!",
    removedFromCart: "Eliminado del carrito",
    cartUpdated: "Carrito actualizado",
    loginRequired: "Debes iniciar sesión para añadir al carrito",
    welcomeBack: "¡Bienvenido!",
    accountCreated: "¡Cuenta creada! ¡Bienvenido a MRC Boutique!",
    productCreated: "¡Producto creado!",
    productUpdated: "¡Producto actualizado!",
    productDeleted: "¡Producto eliminado!",
    errorAddingToCart: "Error al añadir al carrito",
    errorCheckout: "Error al crear la sesión de pago",
    fillAllFields: "Completa todos los campos",
    passwordsDontMatch: "Las contraseñas no coinciden",
    passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
    invalidCredentials: "Correo o contraseña inválidos",
  },
  
  pt: {
    // Navbar
    products: "Produtos",
    electronics: "Eletrônicos",
    clothing: "Roupas",
    home: "Casa",
    beauty: "Beleza",
    login: "Entrar",
    logout: "Sair",
    myOrders: "Meus Pedidos",
    adminPanel: "Painel Admin",
    
    // Home
    welcome: "Bem-vindo!",
    tagline: "Um simples clique",
    heroTitle: "MRC Boutique, LLC",
    heroDesc: "Descubra nossa coleção de produtos. Tudo o que você precisa, em um só lugar.",
    shopNow: "Comprar Agora",
    register: "Cadastrar",
    categories: "Categorias",
    exploreCategories: "Explore todas as nossas categorias de produtos",
    popularProducts: "Produtos Populares",
    discoverPopular: "Descubra nossos produtos mais populares",
    viewAll: "Ver Tudo",
    dontMissPromotions: "Não Perca Nossas Promoções!",
    signUpForNews: "Cadastre-se agora para receber as últimas notícias e promoções especiais.",
    createFreeAccount: "Criar Conta Grátis",
    
    // Features
    fastDelivery: "Entrega Rápida",
    deliveryDesc: "Entrega para todos os lugares",
    security: "Segurança",
    securityDesc: "Pagamento 100% seguro",
    easyPayment: "Pagamento Fácil",
    paymentDesc: "Aceita todos os cartões",
    
    // Products
    allProducts: "Todos os Produtos",
    discoverCollection: "Descubra nossa coleção de produtos",
    searchProducts: "Buscar produtos...",
    search: "Buscar",
    allCategories: "Todas as Categorias",
    clearFilters: "Limpar Filtros",
    productsFound: "produtos encontrados",
    noProductsFound: "Nenhum produto corresponde à sua busca",
    
    // Product Detail
    backToProducts: "Voltar aos Produtos",
    available: "Disponível",
    onlyLeft: "Apenas {count} restantes",
    outOfStock: "Fora de estoque",
    quantity: "Quantidade",
    addToCart: "Adicionar ao Carrinho",
    deliveryAvailable: "Entrega disponível",
    qualityGuarantee: "Garantia de qualidade",
    securePayment: "Pagamento seguro",
    similarProducts: "Produtos Similares",
    
    // Cart
    yourCart: "Seu Carrinho",
    itemsInCart: "itens no seu carrinho",
    cartEmpty: "Seu carrinho está vazio",
    noProductsYet: "Você ainda não adicionou nenhum produto ao seu carrinho.",
    continueShopping: "Continuar Comprando",
    orderSummary: "Resumo do Pedido",
    subtotal: "Subtotal",
    shipping: "Frete",
    free: "Grátis",
    total: "Total",
    payNow: "Pagar Agora",
    processing: "Processando...",
    loginToCheckout: "Faça login para ver seu carrinho e comprar produtos.",
    removeFromCart: "Remover do carrinho",
    
    // Auth
    email: "Email",
    password: "Senha",
    confirmPassword: "Confirmar Senha",
    fullName: "Nome Completo",
    noAccount: "Não tem uma conta?",
    haveAccount: "Já tem uma conta?",
    registerNow: "Cadastrar",
    loginNow: "Entrar",
    createAccount: "Criar Conta",
    creatingAccount: "Criando conta...",
    loggingIn: "Entrando...",
    
    // Orders
    myOrdersTitle: "Meus Pedidos",
    orders: "pedidos",
    noOrders: "Sem pedidos",
    noOrdersYet: "Você ainda não fez nenhum pedido.",
    startShopping: "Começar a Comprar",
    orderNumber: "Número do Pedido",
    date: "Data",
    paymentStatus: "Status do Pagamento",
    paid: "Pago",
    pending: "Pendente",
    
    // Order Status
    statusPending: "Pendente",
    statusProcessing: "Em preparação",
    statusShipped: "Enviado",
    statusDelivered: "Entregue",
    statusCancelled: "Cancelado",
    
    // Checkout Success
    verifyingPayment: "Verificando pagamento...",
    pleaseWait: "Por favor aguarde um momento",
    thankYou: "Obrigado pelo seu pedido!",
    paymentSuccess: "Seu pagamento foi bem-sucedido. Prepararemos seu pedido imediatamente.",
    viewOrders: "Ver Pedidos",
    sessionExpired: "Sessão expirada",
    errorOccurred: "Ocorreu um erro",
    sessionExpiredMsg: "Sua sessão de pagamento expirou. Por favor tente novamente.",
    errorMsg: "Não conseguimos verificar seu pagamento. Por favor entre em contato com o suporte.",
    returnToCart: "Voltar ao Carrinho",
    
    // Admin
    manageProducts: "Gerenciar produtos",
    totalProducts: "produtos no total",
    addProduct: "Adicionar Produto",
    newProduct: "Novo Produto",
    editProduct: "Editar Produto",
    productName: "Nome",
    description: "Descrição",
    price: "Preço",
    stock: "Estoque",
    category: "Categoria",
    selectCategory: "Selecionar categoria",
    imageUrl: "URL da Imagem",
    update: "Atualizar",
    createProduct: "Criar Produto",
    actions: "Ações",
    
    // Footer
    quickLinks: "Links Rápidos",
    customerService: "Atendimento ao Cliente",
    trackOrder: "Rastrear Pedido",
    returns: "Devoluções",
    faq: "FAQ",
    contactUs: "Contate-nos",
    allRightsReserved: "Todos os direitos reservados.",
    footerTagline: "Um clique para encontrar tudo o que você precisa. A loja online de confiança.",
    
    // Messages
    addedToCart: "adicionado ao carrinho!",
    removedFromCart: "Removido do carrinho",
    cartUpdated: "Carrinho atualizado",
    loginRequired: "Você precisa fazer login para adicionar ao carrinho",
    welcomeBack: "Bem-vindo de volta!",
    accountCreated: "Conta criada! Bem-vindo à MRC Boutique!",
    productCreated: "Produto criado!",
    productUpdated: "Produto atualizado!",
    productDeleted: "Produto excluído!",
    errorAddingToCart: "Erro ao adicionar ao carrinho",
    errorCheckout: "Erro ao criar sessão de pagamento",
    fillAllFields: "Preencha todos os campos",
    passwordsDontMatch: "As senhas não correspondem",
    passwordTooShort: "A senha deve ter pelo menos 6 caracteres",
    invalidCredentials: "Email ou senha inválidos",
  }
};

const languageNames = {
  ht: { name: 'Kreyòl', flag: '🇭🇹' },
  en: { name: 'English', flag: '🇺🇸' },
  fr: { name: 'Français', flag: '🇫🇷' },
  es: { name: 'Español', flag: '🇪🇸' },
  pt: { name: 'Português', flag: '🇧🇷' }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('mrc_language');
    return saved || 'ht';
  });

  useEffect(() => {
    localStorage.setItem('mrc_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['ht']?.[key] || key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage: changeLanguage, 
      t,
      languages: languageNames,
      availableLanguages: Object.keys(translations)
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
